import merge from 'lodash/merge';
import { TableMeta } from '../models';

import { DEFAULT_TABLE_OPTIONS } from '..';

/**
 * This method determines the correct set of table options to be used in uik Grid by merging the defaults with custom options
 * @param tableOptions options passed to DataTable props
 * @returns table options to be used
 */
export const getTableOptions = <TData>(tableOptions?: TableMeta): TableMeta => {
  const options = tableOptions ? merge({}, DEFAULT_TABLE_OPTIONS, tableOptions) : DEFAULT_TABLE_OPTIONS;

  // if row virtualization is enabled, use sticky header
  // if (options.rowVirtualization.enabled) {
  //   options.enableStickyHeader = true;
  // }

  return options;
};
